<script lang="ts">
	// Stores
	import { sidePanelStateCombined } from 'src/stores/ui/sidepanel-public';
	import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { devices } from 'src/stores/lists/devices';

	// Services and configs
	import { devices_config } from 'src/configs/devices';
	// Helpers
	import { is_gen_2, real_id } from 'src/helpers/interface_helpers';

	// Components
	import InputsReaderVisualizerV2 from 'src/components/Controls/Indicators/InputsReaderVisualizerV2.svelte';
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	// Types
	import type { Device } from 'src/types/Device.ts';
	import { createGen1StatusLabels, getGen1DeviceStatuses } from '../../gen1-main-helpers';
	import DeviceLabelList from 'src/components/Sidepanel/DeviceViews/DeviceLabelList.svelte';

	/**
	 * Main control tab for the SHIX3-1 (Gen1 input device) sidepanel drawer.
	 *
	 * Responsibilities:
	 * - displays input reader visualizer for the device
	 * - shows firmware incompatibility warnings
	 *
	 * @param {Device} device - The device for which the information is displayed.
	 */
	export let device: Device;

	let btnType: string;
	$: {
		if (typeof status?.inputs !== 'undefined') {
			btnType = settings?.inputs?.[device?.channel]?.btn_type;
		} else if (is_gen_2(device)) {
			btnType = settings?.['input:' + device?.channel]?.type;
		} else {
			btnType = undefined;
		}
	}
	$: isButton = btnType === 'toggle' || btnType === 'switch';

	$: id = $sidePanelStateCombined?.id;
	$: deviceData = device || $devices[id];

	$: deviceConfig = devices_config?.[deviceData?.type];

	$: statusStore = getDeviceStatus(deviceData?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(deviceData?.id);
	$: settings = $settingsStore;

	$: _statuses = getGen1DeviceStatuses(status, device, settings, deviceConfig);
	$: labelList = createGen1StatusLabels(_statuses);
</script>

<DeviceViewStateWrapper device={deviceData}>
	<div
		slot="staticTop"
		class="label-list-wrapper mb-s d-flex flex-direction-column justify-content-center"
	>
		<DeviceLabelList {labelList} />
		<DeviceNotificationLabel deviceId={deviceData?.id} />
	</div>

	<div class="flex-full-height align-items-center justify-content-center" slot="content">
		{#if isButton && deviceData && status !== undefined && settings !== undefined && deviceConfig !== undefined && status?.online}
			<InputsReaderVisualizerV2 device={deviceData} {status} {settings} />
		{/if}
	</div>

	<div class="flex-full-height justify-content-end" slot="staticBottom">
		{#if !isButton && deviceData && status !== undefined && settings !== undefined && deviceConfig !== undefined && status?.online}
			<InputsReaderVisualizerV2 device={deviceData} {status} {settings} />
		{/if}
	</div>
</DeviceViewStateWrapper>
